import { Skeleton, TableCell } from '@mui/material';

import DateText from '@/components/DateText';
import { DateTextVariants } from '@/components/DateText/useDateText';

type Props = {
  date: string | undefined | null;
  isLoading: boolean;
};

const DateCell = ({ date, isLoading }: Props) => (
  <TableCell align='right'>
    {isLoading && !date ? (
      <Skeleton
        variant='text'
        width={45}
        sx={{ ml: 'auto' }}
      />
    ) : (
      <DateText
        dateString={date ?? ''}
        variant={DateTextVariants.DAY_MONTH}
      />
    )}
  </TableCell>
);

export default DateCell;
